import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {alertIcErrorOutline24px} from '@ey/motif-react-wrapper/assets/icons/index';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifInput from '@ey/motif-react-wrapper/Input';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {IconoirWarningCircle} from '@ey-xd/motif-icon';
import LoadingIndicator from '@ey/canvascoreservices/LoadingIndicator';
import Utility from '@ey/canvascoreservices/utils/utilityfunctions';
import {stringFormat} from '@ey/utils';
import Modal from '../../ADCModal/Modal';

const Content = (props) => {
	const {
		isEditModal,
		showModal,
		setShowModal,
		labels,
		onClose,
		errorComponent,
		createTagGroupAction,
		entityId,
		updateTagGroupAction,
		tagGroupItem
	} = props;
	const [inputFields, setInputFields] = useState({
		tagGroupId: '',
		tagGroupName: '',
		hasValidation: false
	});
	const [isLoading, setIsLoading] = useState(false);
	const isTagGrougCreated = useRef(false);
	const modalDescription = isEditModal ? labels.editModalDescription : labels.createModalDescription;

	useEffect(() => {
		if (isEditModal) {
			setInputFields({
				tagGroupId: tagGroupItem.tagGroupId,
				tagGroupName: tagGroupItem.tagGroupName,
				hasValidation: false
			});
		}
	}, []);

	const onHide = () => {
		setInputFields({
			inputFields: '',
			hasValidation: false
		});
		setShowModal(false);
		isTagGrougCreated.current && onClose();
	};

	const saveAndCreateAnother = () => {
		createEditTagGroupEndpoint(true);
	};

	const saveAndClose = () => {
		createEditTagGroupEndpoint();
	};

	const createEditTagGroupEndpoint = (createAnother = false) => {
		if (inputFields.tagGroupName.trim().length === 0) {
			setInputFields({
				...inputFields,
				hasValidation: true
			});
			return;
		}
		setIsLoading(true);
		let payload = {entityId: entityId, name: inputFields.tagGroupName.trim()};
		const action = isEditModal ? updateTagGroupAction : createTagGroupAction;
		action(payload)
			.then(() => {
				setIsLoading(false);
				createAnother
					? (setInputFields({
							tagGroupName: '',
							hasValidation: false
					  }),
					  (isTagGrougCreated.current = true))
					: onClose();
			})
			.catch(() => {
				setIsLoading(false);
				return;
			});
	};

	const handleInputChange = (e) => {
		let inputField = e.target.value;
		setInputFields({
			tagGroupName: e.target.value,
			hasValidation: inputField.trim().length === 0 || inputField.trim() === ''
		});
	};

	const renderErrorMsg = (msg) => {
		return (
			<MotifErrorMessage
				aria-live="assertive"
				id="entity-name-error"
				role="alert"
				icons={{error: <MotifIcon src={alertIcErrorOutline24px} />}}
			>
				{msg}
			</MotifErrorMessage>
		);
	};

	const renderBody = () => {
		return (
			<section className={'modalBody'}>
				<section className="modal-description motif-body1-default-light">
					{Utility.createRichTextElement(
						isEditModal
							? stringFormat(modalDescription, labels.save)
							: stringFormat(modalDescription, labels.saveAndCloseLabel, labels.saveAndCreateLabel)
					)}
				</section>
				<section className="tag-group-section">
					<MotifFormField>
						<MotifLabel position="in" htmlFor="tag-group-name">
							{labels.tagGroupNameLabel}
						</MotifLabel>
						<MotifInput
							id="tagGroupName"
							maxLength={200}
							value={inputFields.tagGroupName}
							onChange={(e) => handleInputChange(e)}
							labelPosition="in"
							suffix={
								inputFields.hasValidation &&
								(inputFields.tagGroupName === '' || inputFields.tagGroupName.trim() === '') && (
									<MotifIcon fill="var(--red-600)" size="16" src={IconoirWarningCircle} />
								)
							}
						/>
						<section className="error-message-styling">
							{inputFields.hasValidation && renderErrorMsg(labels.required)}
						</section>
					</MotifFormField>
				</section>
			</section>
		);
	};

	return (
		<Modal
			show={showModal}
			modalsize={'small'}
			showButtons={true}
			title={isEditModal ? labels.editModalTitle : labels.createModalTitle}
			confirmBtnTitle={isEditModal ? labels.save : labels.saveAndCloseLabel}
			saveCreateBtnTitle={isEditModal ? null : labels.saveAndCreateLabel}
			closeBtnTitle={labels.cancel}
			closeTitle={labels.cancel}
			modalBodyStyle={'CreateEditControlModalBody customScrollbar'}
			modalContainerClass={'CreateEditControlModalContainer'}
			onHide={() => onHide()}
			closeIconTitle={labels.cancel}
			isOkButtonDisabled={isLoading}
			isSaveCreateButtonDisabled={isLoading}
			isCancelButtonDisabled={isLoading}
			onOkClick={() => {
				saveAndClose();
			}}
			onSaveCreateClick={() => {
				saveAndCreateAnother() || null;
			}}
			showSaveAndCreateNewButton={true}
			disableClose={isLoading}
			showError
			errorChildren={errorComponent}
		>
			<StyledBodyContent>
				{isLoading ? (
					<section className="loader-section">
						<LoadingIndicator show view="inlineView" />
					</section>
				) : (
					<>
						{renderBody()}
					</>
				)}
			</StyledBodyContent>
		</Modal>
	);
};

export default Content;

const StyledBodyContent = styled.section`
	display: flex;
	width: 100%;
	.modalBody {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	.modal-description {
		padding-bottom: var(--px-24);
		border-bottom: var(--px-1) solid var(--neutrals-100);
	}
	.error-message-styling {
		height: var(--px-24);
	}
	.tag-group-section {
		padding-top: var(--px-24);
	}
	.loader-section {
		flex: 1;
		width: 100%;
	}
	 .motif-progress-loader {
		z-index: 10;
		opacity: 0.6;
	}
`;
